/**
 * this function checks if the string is only spaces
 * @param {String} str
 * @returns {Boolean} true if str is only spaces
 */
export function isOnlySpaces(str) {
  return !/\S/.test(str);
}
